import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { createRoot } from 'react-dom/client'
import { EuiProvider } from '@elastic/eui';
import  Placeholder  from '../dist/components/Placeholder';
import { BrowserRouter as Router } from 'react-router-dom';

import createCache from '@emotion/cache';

const euiCache = createCache({
    key: 'eui',
    container: document.querySelector('meta[name="eui-style-insert"]'),
  });
  
euiCache.compat = true;

const hideStickyElements = () => {
  if (window.innerWidth <= 767) { 
    const footer = document.querySelector('footer');

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.3
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        const fadeElements = document.querySelectorAll('.fade-out-element');
        if (entry.isIntersecting) {
          fadeElements.forEach( el => {
            el.classList.add('fade-out');
            setTimeout(() => {
              el.classList.add('d-none');
            }, 300);
          })
        } else {
          fadeElements.forEach( el => {
            el.classList.remove('d-none');
            setTimeout(() => {
              el.classList.remove('fade-out');
            }, 10);          
          })        
        }
      });
    }, options);
      
    observer.observe(footer);
  }  
}
document.addEventListener('DOMContentLoaded', hideStickyElements);

const Section = {
  load: (section) => {       
    const container = document.querySelector('#searchkit-faceting-container');    
    const root = createRoot(container) 
    const overrides = 
      {
        "colors": {
          "LIGHT": {
            "primary": "#2e4200",
            "accent": "#5c97b8",
            "success": "#949621",
            "warning": "#D49C64",
            "danger": "#ff9a4d"
          }
        }
      }
    root.render(
      <React.StrictMode>
        <Router>
          <EuiProvider colorMode='light' cache={euiCache} modify={overrides}>
            <Placeholder />
          </EuiProvider>
        </Router>
      </React.StrictMode>
    );
  }
}
export default Section;